import { DialogsProvider } from '@toolpad/core/useDialogs';
import { Outlet } from 'react-router';

export default function RootLayout() {
  return (
    <DialogsProvider>
      <Outlet />
    </DialogsProvider>
  );
}
